export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENV;
export const DEV = process.env.NEXT_PUBLIC_ENV !== 'prod';
export const PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'prod';

export const BRAND = process.env.NEXT_PUBLIC_BRAND || 'boi';
export const brandLeg = BRAND === 'leg';
export const brandBoi = BRAND === 'boi';
export const brandBog = BRAND === 'bog';
